<template>
  <div class="media-tile"> 
    <div class="text-center">
      <img
        class="media-proper"
        :src="media.signed_full_url"
      />
    </div>
    <div class="d-flex justify-content-between">
      <div class="media-label"> 
        {{ media.name }}
      </div>
      <a
        class="download-button"
        :href="API_SUFFIX + '/api/media/download/' + media.uuid_id"
        @click.prevent="downloadMedia"
      >
        Download
      </a>
    </div>
  </div>
</template>

<script>
import MediaService from "../services/media.service";

export default {
  props: {
    media: Object,
  },
  name: "MediaTile",
  data: function() {
    return {
      API_SUFFIX: process.env.VUE_APP_API_SUFFIX,
    };
  },
  methods: {
    downloadMedia() {
      MediaService.downloadMedia(this.media.uuid_id).then((data) => {
        if (window.webkit) {
          let url = data.url;
          window.webkit.messageHandlers.mediaimport.postMessage({
            url: data.url,
            fileName: data.fileName,
          });
        } else {
          window.location = data.url;
        }
      });
    },
  },
  beforeMount() {},
};
</script>

<style scoped>
.media-tile {
  background: #F8F9FA;
  border: 1px solid var(--isim-light-icon);
  border-radius: 4px;
  margin: 8px;
}

.media-proper {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  max-height: 360px;
  max-width: 100%;
  object-fit: contain;
}

.media-label {
  font-size: 16px;
  padding: 8px;
}

.download-button {
  font-size: 12px;
  text-decoration: underline;
  color: var(--isim-primary);
  padding: 10px 8px;
}
</style>
